import React from "react";
import { Check, Moon, Sun } from "lucide-react";
import { useTranslation } from "react-i18next";
import { THEME_MODES, isDarkTheme } from "../../utils/themeMode";

export default function SettingsAppearancePage({ themeMode, onThemeModeChange }) {
  const { t } = useTranslation();
  const darkActive = isDarkTheme(themeMode);
  const options = [
    { value: THEME_MODES.LIGHT, active: !darkActive, Icon: Sun, title: t("light_mode", { defaultValue: "Light mode" }), description: t("settings_appearance_light_description", { defaultValue: "Use a bright appearance for daytime viewing." }) },
    { value: THEME_MODES.DARK, active: darkActive, Icon: Moon, title: t("dark_mode", { defaultValue: "Dark mode" }), description: t("settings_appearance_dark_description", { defaultValue: "Use a darker appearance in low light." }) },
  ];
  return (
    <div className="rp-settings-options" role="group" aria-label={t("settings_appearance", { defaultValue: "Appearance" })}>
      {options.map(({ value, active, Icon, title, description }) => (
        <button key={value} type="button" className={`rp-settings-option rp-settings-option--with-icon${active ? " rp-settings-option--active" : ""}`} aria-pressed={active} onClick={() => onThemeModeChange?.(value)}>
          <span className="rp-settings-option__leading" aria-hidden="true"><Icon size={20} /></span>
          <span className="rp-settings-option__copy"><strong>{title}</strong><span>{description}</span></span>
          <span className="rp-settings-option__check" aria-hidden="true">{active ? <Check size={20} /> : null}</span>
        </button>
      ))}
    </div>
  );
}
